import React from 'react'
import {
  Box,
  HStack,
  VStack,
  Input,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  SimpleGrid,
  Button,
  useColorModeValue,
} from '@chakra-ui/react'

export const PRESET_COLORS = [
  '#E03400',
  '#BB36D3',
  '#3A863D',
  '#2563EB',
  '#F59E0B',
  '#10B981',
  '#EC4899',
  '#8B5CF6',
  '#06B6D4',
  '#C0C0C0', // Silver (allowed, distinct from unavailable dark gray)
  '#0D9488', // Teal
  '#DC2626', // Red
  '#D97706', // Amber
  '#4F46E5', // Indigo
  '#000000', // Black
  '#FFFFFF', // White
]

export function ColorPickerPopover({ value = '#C0C0C0', onChange, size = 'xs' }) {
  const popoverBg = useColorModeValue('#FFFFFF', '#1E293B')
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.200')
  const inputBg = useColorModeValue('#F8FAFC', '#0F172A')

  return (
    <HStack spacing={1.5} align="center">
      <Popover placement="left" isLazy closeOnBlur>
        <PopoverTrigger>
          <Box
            as="button"
            w="24px"
            h="24px"
            borderRadius="4px"
            bg={value || '#CCCCCC'}
            border="1.5px solid"
            borderColor={borderColor}
            boxShadow="inset 0 0 0 1px rgba(0,0,0,0.15)"
            cursor="pointer"
            flexShrink={0}
            _hover={{ transform: 'scale(1.08)' }}
            _active={{ transform: 'scale(0.96)' }}
            transition="all 0.15s"
          />
        </PopoverTrigger>
        <PopoverContent
          bg={popoverBg}
          borderColor={borderColor}
          w="220px"
          p={2}
          boxShadow="xl"
          _focus={{ outline: 'none' }}
        >
          <PopoverBody p={1}>
            <VStack spacing={2.5} align="stretch">
              <SimpleGrid columns={4} spacing={1.5}>
                {PRESET_COLORS.map((c) => (
                  <Button
                    key={c}
                    size="xs"
                    h="24px"
                    p={0}
                    bg={c}
                    border="1px solid"
                    borderColor={c === '#FFFFFF' ? 'gray.300' : 'rgba(0,0,0,0.2)'}
                    borderRadius="4px"
                    _hover={{ transform: 'scale(1.1)' }}
                    onClick={() => onChange(c)}
                  />
                ))}
              </SimpleGrid>

              <HStack spacing={1}>
                <Input
                  type="color"
                  size="xs"
                  w="36px"
                  h="26px"
                  p={0}
                  cursor="pointer"
                  value={value || '#CCCCCC'}
                  onChange={(e) => onChange(e.target.value)}
                />
                <Input
                  size="xs"
                  h="26px"
                  bg={inputBg}
                  value={value || ''}
                  placeholder="#000000"
                  onChange={(e) => onChange(e.target.value)}
                />
              </HStack>
            </VStack>
          </PopoverBody>
        </PopoverContent>
      </Popover>

      <Input
        size={size}
        w="75px"
        h="24px"
        fontSize="xs"
        value={value || ''}
        placeholder="#000000"
        onChange={(e) => onChange(e.target.value)}
      />
    </HStack>
  )
}
